module.exports = __webpack_public_path__ + "61963ca484b24600b289eea45d8f12a4.png";